module.exports = __webpack_public_path__ + "static/media/NotoSans-BoldItalic.6cf6c588.eot";